import * as React  from 'react'
import { connect } from 'react-redux'

import CircularProgress     from '@material-ui/core/CircularProgress/CircularProgress'
import Grid                 from '@material-ui/core/Grid/Grid'
import Snackbar             from '@material-ui/core/Snackbar/Snackbar'
import Typography           from '@material-ui/core/Typography'
import { FormattedMessage } from 'react-intl'

import { ApplicationState, getToastState } from '../../redux/ducks'

const mstp = (state: ApplicationState) =>
  getToastState(state)

type AppToastProps = ReturnType<typeof mstp>

const AppToast = ({
  hasLoader,
  isDisplayed,
  message,
  values,
  error,
  i18nPrefix,
  withoutI18nPrefix,
}: AppToastProps) => {
  const i18nId = withoutI18nPrefix
    ? message
    : (i18nPrefix || 'toast.') + message

  const phrasing = {
    message:
      (
        <FormattedMessage
          id={i18nId}
          values={values}
        />
      ),
  }

  let loader, toastMessage

  if (hasLoader) {
    loader = (
      <Grid item>
        <CircularProgress
          color={'inherit'}
          size={15}
        />
      </Grid>
    )
  }

  if (error) {
    toastMessage = (
      <Typography color={'error'}>
        {phrasing.message}
      </Typography>
    )
  } else {
    toastMessage = phrasing.message
  }

  const toastContent = (
    <>
      <Grid
        container
        justify={'space-between'}
        alignItems={'center'}
        spacing={16}
      >
        <Grid item>
          {toastMessage}
        </Grid>
        {loader}
      </Grid>
    </>
  )

  return (
    <Snackbar
      autoHideDuration={4000}
      open={isDisplayed}
      message={toastContent}
      anchorOrigin={{
        vertical:   'bottom',
        horizontal: 'left',
      }}
    />
  )
}

export default connect(mstp)(AppToast)



// WEBPACK FOOTER //
// ./src/components/organisms/AppToast.tsx